import Axios from "@/plugins/Axios";

export class PlanosBimestraisService {
  async planoBimestral(gestaoDeAulaId, etapa, disciplinaId) {
    const response = await Axios().get(
      `planos-bimestrais/plano-bimestral/${gestaoDeAulaId}/${etapa}/${disciplinaId}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async baixarDocumentoPlanoAnual(gestaoDeAulaId, etapa_id, disciplinaId) {
    const response = await Axios()
      .get(
        `planos-bimestrais/baixar-documento-anual/${gestaoDeAulaId}/${etapa_id}/${disciplinaId}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestaoDeAulaId}.pdf`;
        link.click();
      });
    return response;
  }

  async planoBimestralInterdisciplinar(gestaoDeAulaId, etapa_id) {
    const response = await Axios().get(
      `planos-bimestrais/plano-bimestral-interdisciplinar/${gestaoDeAulaId}/${etapa_id}`
    );
    return response.data;
  }

  async createOrUpdateInterdisciplinar(plano) {
    const response = await Axios().post(
      `planos-bimestrais/criar-plano-bimestral-interdisciplinar`,
      {
        plano,
      }
    );
    return response.data;
  }

  async baixarDocumentoPlanoAnualInfantil(gestaoDeAulaId, etapa_id) {
    const response = await Axios()
      .get(`planos-bimestrais/baixar-documento-anual/${gestaoDeAulaId}/${etapa_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestaoDeAulaId}.pdf`;
        link.click();
      });
    return response;
  }
}
export default new PlanosBimestraisService();
